import React, { useState } from 'react';
import {
  AppBar,
  Grid,
  IconButton,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import useMyPage from '@hooks/useMyPage';
import EmailEditContainer from './EmailEditContainer';
import EmailConfirmPasswordContainter from './EmailConfirmPasswordContainter';
import {
  DepartmentEditPresenter,
  FieldEditInputPresenter
} from './FieldEditPresenter';
import { useHistory } from 'react-router-dom';
import { ChevronLeft } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
interface Props {
  onSubmit: (_: any) => void;
  onCancel: () => void;
}

const MyPageEditPresenter: React.FC<Props> = ({ onSubmit, onCancel }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();
  const { profile } = useMyPage();
  const history = useHistory();
  const label = profile.label ?? '';
  const [confirmSuccess, setConfirmSuccess] = useState(false);

  const editItemRoute = () => {
    const fieldName = profile.field[0].fieldName ?? '';
    switch (fieldName) {
      case 'email':
        return (
          <>
            {confirmSuccess ? (
              <EmailEditContainer onSubmit={onSubmit} onCancel={onCancel} />
            ) : (
              <EmailConfirmPasswordContainter
                confirmSuccess={() => setConfirmSuccess(true)}
              />
            )}
          </>
        );
      case 'department':
        return (
          <DepartmentEditPresenter onSubmit={onSubmit} onCancel={onCancel} />
        );
      default:
        return (
          <FieldEditInputPresenter onSubmit={onSubmit} onCancel={onCancel} />
        );
    }
  };

  const onClickBack = () => {
    history.goBack();
  };

  return (
    <>
      {matches && (
        <>
          <AppBar elevation={0} position="sticky" className={classes.appBar}>
            <IconButton onClick={onClickBack}>
              <ChevronLeft width={24} height={24} fill={colorSet.gray900} />
            </IconButton>
            <CustomizedTypography
              className={classes.title}
              variant="body1"
              fontWeight="500"
              color="textPrimary"
            >
              {label}
            </CustomizedTypography>
          </AppBar>
        </>
      )}
      <Grid
        container
        direction="column"
        style={{ padding: matches ? '20px 16px' : '0px 16px' }}
      >
        <Grid container>
          <CustomizedTypography
            variant={matches ? 'h3' : 'h2'}
            gutterBottoms={matches ? 20 : 36}
            fontWeight={'500'}
          >
            {label} 수정
          </CustomizedTypography>
        </Grid>
        <Grid container direction="column">
          {editItemRoute()}
        </Grid>
      </Grid>
    </>
  );
};

export default MyPageEditPresenter;

export const useStyles = makeStyles(() => ({
  appBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 16px 0px 0px',
    height: 49,
    backgroundColor: colorSet.gray000,
    borderBottom: `1px solid ${colorSet.gray400}`
  },
  title: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)'
  }
}));
